export default __webpack_public_path__ + "static/popup-mobile-x2-3d4ed743cc6b732925aa165197163224.webp";